import {AppStateService} from "../services/appStateService";
import {DrawingConfigurationInterface} from "../components/drawingComponent/interface/drawingConfigurationInterface";

export class DrawingConfigStore {

    private readonly appStateService = new AppStateService();
    private config = {};

    get(): DrawingConfigurationInterface
    {
        return this.appStateService.getDrawingConfiguration();
    }

    set(configuration)
    {
        this.appStateService.setCurrentDrawingConfiguration(this.config);
    }
}
